import ActionButton from 'components/ActionButton';
import { useFeatureToggle } from 'hooks';
import type { VariantId } from 'models/product';
import { getTestDataAttrFrom } from 'utils/helpers';
import { useI18n } from 'utils/i18n';

import {
	useProductPrintContext,
	useStockContext,
} from './ProductDetailsContext';

interface Props {
	onPurchaseButtonClick: () => void;
	onWishlistButtonClick: () => void;
	selectedAccessoryUpsellIds: VariantId[];
}

export default function ButtonPanel({
	onPurchaseButtonClick,
	onWishlistButtonClick,
	selectedAccessoryUpsellIds,
}: Props) {
	const { t } = useI18n();
	const { onlineCommerceEnabled, wishlistEnabled } = useFeatureToggle();
	const { isPurchasable } = useStockContext();
	const { printPlacements } = useProductPrintContext();
	const buttonCountText =
		selectedAccessoryUpsellIds.length > 0
			? ` (${selectedAccessoryUpsellIds.length + 1})`
			: '';

	return (
		<div className="mt-r-md space-y-2">
			{onlineCommerceEnabled && (
				<ActionButton
					displayWidth="full"
					size="lg"
					variant="cta"
					leadingIcon={isPurchasable ? 'cart' : 'cart-off'}
					disabled={!isPurchasable}
					onClick={onPurchaseButtonClick}
					data-cy={getTestDataAttrFrom('add-to-cart')}
				>
					{t('general_add_to_cart_button_text')}
					{buttonCountText}
				</ActionButton>
			)}
			{wishlistEnabled && (
				<div className="w-full">
					<ActionButton
						displayWidth="full"
						variant="secondary"
						leadingIcon="shopping-list"
						disabled={Boolean(printPlacements?.length)}
						onClick={onWishlistButtonClick}
						data-cy={getTestDataAttrFrom('add-to-wishlist')}
					>
						{t('general_add_to_wishlist_button_text')}
						{buttonCountText}
					</ActionButton>
				</div>
			)}
		</div>
	);
}
ButtonPanel.displayName = 'ButtonPanel';
